import React__default from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import { Link } from 'react-router-dom';

var _excluded = ["to", "children"];
var ButtonLink = function ButtonLink(_ref) {
  var to = _ref.to,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /^https?:\/\//.test(to) || /^mailto?:/.test(to) || /^tel?:/.test(to) ? /*#__PURE__*/React__default.createElement(Button, _extends({}, props, {
    elem: "a",
    href: to
  }), children) : /*#__PURE__*/React__default.createElement(Button, _extends({}, props, {
    elem: Link,
    to: to
  }), children);
};

export { ButtonLink };
//# sourceMappingURL=index.js.map
